module.exports = __webpack_public_path__ + "static/media/ImageOne.9ca79dba.jpg";